import { render, staticRenderFns } from "./OrganismTicketManagement.vue?vue&type=template&id=007ec880&scoped=true&"
import script from "./OrganismTicketManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismTicketManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTicketManagement.vue?vue&type=style&index=0&id=007ec880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ec880",
  null
  
)

export default component.exports